import { h, render } from "preact";
import "./style.css";

import App from "./App";

const defaultConfiguration = {
  accountUrl: "https://accounts.platform.sh",
  docsUrl: "",
  source: "accounts",
  showProjectsMenu: true,
  includeBilling: true,
  includeSupport: true,
  nameOrAvatar: false,
  adminOnly: false,
  betaToggle: false,
  customAccountMenuItems: [],
  getQueryString: path => ({
    path
  })
};

let appRef;

const getAppRef = ref => {
  if (ref) {
    appRef = ref;
  }
};

export function init(domElement, config = defaultConfiguration) {
  const newConfig = { ...defaultConfiguration, ...config };

  render(<App ref={getAppRef} {...newConfig} />, domElement);
}

export const updateContext = props => appRef && appRef.updateContext(props);

export default init;



// WEBPACK FOOTER //
// ./src/index.js